import React from 'react';
import { Box, Typography } from '@mui/material';
import { Table as AntTable, Tag, Input, Switch, Form, Select, Button as AntButton, Space } from 'antd';
import InputForm from '../../InputT';
import SearchInput from '../../SearchInput';
import Params from '../../../Types/ParamsPicklist';
import type { ColumnsType } from 'antd/es/table';

let searchModuleBI: Params = { CodeAgence: '', Table: 'BI_MODULE', Colonne1: 'CODMODULE', Colonne2: 'LIBELLE', Colagence: '101', Choix: 22 };

interface Tab1Props {
  form?: any;
  disabled?: boolean;
  isConsultMode?: boolean;
  isAddMode?: boolean;
  isEditMode?: boolean;
  modules: any[];
  selectedModule: any;
  onSelectModule: (mod: any) => void;
  onFilter?: (filter: { FiltreCategorie?: string; FiltreActif?: boolean | null; FiltreLibelle?: string }) => void;
  onConsult?: () => void;
}

const moduleColumns: ColumnsType<any> = [
  { title: 'Code', dataIndex: 'CodModule', key: 'CodModule', width: 120 },
  { title: 'Libellé', dataIndex: 'Libelle', key: 'Libelle', width: 200 },
  { title: 'Catégorie', dataIndex: 'CodCategorie', key: 'CodCategorie', width: 120 },
  { title: 'SP Name', dataIndex: 'SpName', key: 'SpName', width: 180, ellipsis: true },
  { title: 'Niveau Min', dataIndex: 'NiveauMin', key: 'NiveauMin', width: 90, align: 'center' as const },
  { title: 'Ordre', dataIndex: 'Ordre', key: 'Ordre', width: 70, align: 'center' as const },
  {
    title: 'Actif',
    dataIndex: 'Actif',
    key: 'Actif',
    width: 70,
    align: 'center' as const,
    render: (v: boolean) => <Tag color={v ? '#116599' : 'red'}>{v ? 'Oui' : 'Non'}</Tag>,
  },
];

function Tab1(props: Tab1Props) {
  const [searchText, setSearchText] = React.useState('');
  const [filterCategorie, setFilterCategorie] = React.useState('');
  const [filterActif, setFilterActif] = React.useState<string | undefined>(undefined);
  const [filterLibelle, setFilterLibelle] = React.useState('');

  const handleApplyFilter = () => {
    if (props.onFilter) {
      props.onFilter({
        FiltreCategorie: filterCategorie || '',
        FiltreActif: filterActif === 'true' ? true : filterActif === 'false' ? false : null,
        FiltreLibelle: filterLibelle || '',
      });
    }
  };

  const handleClearFilter = () => {
    setFilterCategorie('');
    setFilterActif(undefined);
    setFilterLibelle('');
    if (props.onFilter) {
      props.onFilter({ FiltreCategorie: '', FiltreActif: null, FiltreLibelle: '' });
    }
  };

  const filteredModules = React.useMemo(() => {
    if (!searchText) return props.modules;
    const lower = searchText.toLowerCase();
    return props.modules.filter(
      (m: any) =>
        (m.CodModule || '').toLowerCase().includes(lower) ||
        (m.Libelle || '').toLowerCase().includes(lower) ||
        (m.CodCategorie || '').toLowerCase().includes(lower)
    );
  }, [props.modules, searchText]);

  return (
    <div className='tabItem'>
      <div>
        {/* Formulaire d'informations du module */}
        <Box fontStyle='inherit' className='border' width={'88%'} position={'relative'}>
          {/* Ligne 1: Code Module (SearchInput) + Libellé + Niveau Min + Ordre + Actif */}
          <Box display='flex' fontStyle='inherit' className='border-left'>
            <SearchInput
              notremove
              dissabledLib={props.disabled}
              dissabledCode={props.isConsultMode || props.isEditMode}
              width={4}
              Taille1={80}
              Taille2={200}
              form={props.form}
              Titre='Recherche Module BI'
              label='Code Module'
              name='CodModule'
              Parametre={searchModuleBI}
              handleFunction={props.onConsult}
            />
            <InputForm label='Libellé' name='Libelle' type='text' />

            <InputForm label='Niveau Min.' name='NiveauMin' type='number' />
            <InputForm label='Ordre' name='Ordre' type='number' />
            <Box>
              <Typography variant='body2' sx={{ mb: 0.5 }}>
                Actif
              </Typography>
              <Form.Item name='Actif' valuePropName='checked' noStyle>
                <Switch disabled={props.isConsultMode} />
              </Form.Item>
            </Box>
          </Box>
          {/* Ligne 2: Description */}
          <InputForm label='Description' name='Description' type='TextArea' />

        </Box>

        {/* Liste des modules */}
        <Box fontStyle='inherit' className='border' width={'88%'} position={'relative'} sx={{ mt: 2 }}>
          {/* Barre de filtres backend */}
          <Box display='flex' gap={1} alignItems='center' sx={{ p: 1, mb: 1, flexWrap: 'wrap' }}>
            <Typography variant='h6' fontWeight='bold' sx={{ mr: 2 }}>
              Liste des modules ({filteredModules.length})
            </Typography>
            <Input
              placeholder='Filtrer par catégorie...'
              allowClear
              size='small'
              style={{ width: 150 }}
              value={filterCategorie}
              onChange={(e) => setFilterCategorie(e.target.value)}
            />
            <Input
              placeholder='Filtrer par libellé...'
              allowClear
              size='small'
              style={{ width: 150 }}
              value={filterLibelle}
              onChange={(e) => setFilterLibelle(e.target.value)}
            />
            <Select
              placeholder='Statut'
              allowClear
              size='small'
              style={{ width: 120 }}
              value={filterActif}
              onChange={(v) => setFilterActif(v)}
              options={[
                { value: 'true', label: 'Actif' },
                { value: 'false', label: 'Inactif' },
              ]}
            />
            <Space>
              <AntButton size='small' type='primary' onClick={handleApplyFilter}>Filtrer</AntButton>
              <AntButton size='small' onClick={handleClearFilter}>Effacer</AntButton>
            </Space>
          </Box>
          <Box display='flex' justifyContent='flex-end' sx={{ mb: 1, pr: 1 }}>
            <Input.Search
              placeholder='Recherche locale...'
              allowClear
              size='small'
              style={{ width: 300 }}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </Box>
          <AntTable
            size='small'
            columns={moduleColumns}
            dataSource={filteredModules}
            rowKey='CodModule'
            pagination={{ pageSize: 8, showSizeChanger: false }}
            scroll={{ y: 300, x: 800 }}
            rowSelection={{
              type: 'radio',
              selectedRowKeys: props.selectedModule?.CodModule ? [props.selectedModule.CodModule] : [],
              onChange: (_keys, rows) => {
                if (rows.length > 0 && !props.isAddMode) {
                  props.onSelectModule(rows[0]);
                }
              },
              getCheckboxProps: () => ({
                disabled: props.isAddMode,
              }),
            }}
            onRow={(record) => ({
              onClick: () => {
                if (!props.isAddMode) {
                  props.onSelectModule(record);
                }
              },
              style: { cursor: props.isAddMode ? 'default' : 'pointer' },
            })}
            rowClassName={(record) =>
              props.selectedModule?.CodModule === record.CodModule ? 'ant-table-row-selected' : ''
            }
          />
        </Box>
      </div>
    </div>
  );
}

export default Tab1;
